import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';

import Message from '../../../utils/Message/Message';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  assetTypeData: any;
}
interface IProps {
  GridHeight?: any;
}
export class AssetType extends Component<IProps, IState> {
  private AsetTypeGrid: GridComponent;
  private assetId: number = -1;
  private isAdd: boolean = true;
  public validationRule: Object = { required: true };
  private type:string='assettype'
  constructor(props: IProps) {
    super(props);
    this.AsetTypeGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      visibleDeleteDialog: false,
      assetTypeData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteAssetType() {
    const obj = {
      id: this.assetId,
    };
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getAssetType(this.type);
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addAssetType(objCommer: any) {
    loadingShow(true, 'Adding');
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      asset_code: objCommer.asset_code,
      id: objCommer.id,
      type:this.type
    };

    if (this.isAdd) {
        delete obj.id
        AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getAssetType(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getAssetType(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getAssetType(this.type);
  }

  getAssetType(type:string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ assetTypeData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getAssetType(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addAssetType(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addAssetType(args.data);
    } else if (args.requestType === 'delete') {
      this.assetId = args.data[0].id;
      this.deleteAssetType();
    }
  }

  render() {
    return (
      <div>
        <GridComponent
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.assetTypeData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.AsetTypeGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          actionBegin={this.actionBegin.bind(this)}
          allowExcelExport
          allowPaging={true}
          enablePersistence
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='asset_code'
              headerText='Asset Code'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default AssetType;
